/**
 * Maps a linked-product picker mode to the question IDs in the Data Act
 * questionnaire whose answers the picker controls (name, owner, and
 * assessment-completed). Kept in its own module so it can be consumed by
 * both the flow component and the questionnaire page renderer without
 * tripping React Fast Refresh's "only-export-components" rule.
 */
export type DataActLinkedMode = "related-service" | "connected-product";

const LINKED_FLOW_IDS: Record<
  DataActLinkedMode,
  { name: string; owner: string; completed: string }
> = {
  "related-service": { name: "Q2.6", owner: "Q2.7", completed: "Q2.8" },
  "connected-product": { name: "Q2.12", owner: "Q2.14", completed: "Q2.15" },
};

export function linkedFlowQuestionIds(mode: DataActLinkedMode) {
  return LINKED_FLOW_IDS[mode];
}

/**
 * Synthetic answer-map key used to persist the linked-product picker's
 * internal state (mode + selected peer ids) without leaking JSON into the
 * user-facing "Additional Details" field on Q2.5 / Q2.11.
 *
 * Kept under the `__internal:` prefix so any future generic UI that
 * iterates the answers map can skip these entries.
 */
export function linkedFlowStateQuestionId(mode: DataActLinkedMode): string {
  return mode === "related-service"
    ? "__internal:Q2.5.linkedFlow"
    : "__internal:Q2.11.linkedFlow";
}
